module.exports = __webpack_public_path__ + "static/bg-tiled-mt_324x486_min-d9fe5baa578bd172ca98c13334be421d.png";